import { render, staticRenderFns } from "./RegionBookings.vue?vue&type=template&id=6798a328&scoped=true"
import script from "./RegionBookings.vue?vue&type=script&lang=js"
export * from "./RegionBookings.vue?vue&type=script&lang=js"
import style0 from "./RegionBookings.vue?vue&type=style&index=0&id=6798a328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798a328",
  null
  
)

export default component.exports